import React from 'react'
import AboutFirst from './AboutFirst'
import AboutSecond from './AboutSecond'
import AboutThird from './AboutThird'
import ContactSection from './ContactSection'
// import ContactForm from './ContactForm'

const AboutPage = () => {
  return (
    <div className='py-20 '>
      <AboutFirst/>
      <AboutSecond/>
      <AboutThird/>
      <ContactSection />
      {/* <ContactForm /> */}
    </div>
  )
}

export default AboutPage

